import { render, staticRenderFns } from "./FlowmanagementList.vue?vue&type=template&id=44390016&scoped=true&"
import script from "./FlowmanagementList.vue?vue&type=script&lang=js&"
export * from "./FlowmanagementList.vue?vue&type=script&lang=js&"
import style0 from "./FlowmanagementList.vue?vue&type=style&index=0&id=44390016&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44390016",
  null
  
)

export default component.exports